import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import LoadingSpinner from "../common/Loading";
import SmallLoadingSpinner from "../common/SmallLoading";
import log from "../core/log";
import {
  getAllProductsUnderCorp,
  getAllOrgnaizationIds,
  getAllStoreIds,
  getFilteredData,
  updateProductExpiryDate,
} from "../Api/ApiCalls";

export const ExploreCorporation = () => {
  const location = useLocation();
  const { corporation_code } = location.state || "";
  const [loading, setLoading] = useState(false);
  const [storeLoading, setStoreLoading] = useState(false);
  const [orglLoading, setOrgLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [dateLoading, setDateLoading] = useState(false);
  const [organization, setOrganization] = useState([]);
  const [tempDate, setTempDate] = useState(null);
  const [fieldDisable, setFieldDisable] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [organizationIds, setOrganizationIds] = useState([]);
  const [storeIds, setStoreIds] = useState([]);

  const { register, handleSubmit, reset } = useForm();

  const tdyDate = new Date();
  tdyDate.setHours(0);
  tdyDate.setMinutes(0);
  tdyDate.setSeconds(0);
  tdyDate.setMilliseconds(0);

  const onSubmit = async (data) => {
    setTableLoading(true);
    try {
      const filters = Object.fromEntries(
        Object.entries(data).filter(([key, value]) => {
          const field = value?.trim();
          return field !== "" && field !== undefined;
        })
      );
      if (Object.keys(filters).length !== 0) {
        const result = await getFilteredData({
          ...filters,
          corporation_code,
        });
        if (result.status) {
          setOrganization(result.data);
        } else {
          setOrganization([]);
        }
        setTableLoading(false);
      } else {
        retriveCorporation();
      }
      setSelectedRow(null);
      setTempDate(null);
    } catch (err) {
      console.log(err);
      log("Error while creating user ", err);
      setTableLoading(false);
    }
  };

  const retriveCorporation = async () => {
    setTableLoading(true);
    try {
      const result = await getAllProductsUnderCorp(corporation_code);
      if (result.status) {
        setOrganization(result.data);
      }
      setTableLoading(false);
    } catch (err) {
      console.log(err);
      log("Error while fetching organization data ", err);
      setTableLoading(false);
    }
  };

  const getOrganizationIds = async () => {
    setOrgLoading(true);
    try {
      const data = await getAllOrgnaizationIds(corporation_code);
      if (data) {
        setOrganizationIds(data);
      }
      setOrgLoading(false);
    } catch (err) {
      log(`Error while fetching organizations id's: `, err);
      setOrgLoading(false);
    }
  };
  const getStoreIds = async (organization_code) => {
    try {
      setStoreLoading(true);
      const data = await getAllStoreIds(corporation_code, organization_code);
      if (data) {
        setStoreIds(data);
      }
      setStoreLoading(false);
    } catch (err) {
      log(`Error while fetching organizations id's: `, err);
      setStoreLoading(false);
    }
  };

  const storeFetch = (organizationCode) => {
    if (organizationCode) {
      getStoreIds(organizationCode);
      setFieldDisable(false);
      reset({
        store_code: "",
      });
    } else {
      setStoreIds([]);
      setFieldDisable(true);
      reset();
    }
  };

  const convertToInput = (d) => {
    const date = new Date(d);
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString();
    const day = date.getDate();
    const changedDate =
      year +
      "-" +
      (month.length === 1 ? "0" + month : month) +
      "-" +
      (day < 10 ? "0" + day : day);
    return changedDate;
  };

  const handleSpecificDateChange = (e, index) => {
    const value = new Date(e.target.value).toLocaleDateString("en-US");
    setTempDate(value);
  };

  const handleClose = () => {
    setTempDate(null);
    setSelectedRow(null);
  };

  const handleChangeDate = async (product) => {
    setDateLoading(true);
    try {
      if (tempDate !== "Invalid Date") {
        if (tempDate === null || tempDate === product.expiry_date) {
          setSelectedRow(null);
        } else {
          const datePattern = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
          if (datePattern.test(tempDate)) {
            if (new Date(tempDate) >= tdyDate) {
              product.expiry_date = tempDate;
              const result = await updateProductExpiryDate(product);
              if (result.status) {
                toast.success("Expiry date successfully updated");
                setTempDate(null);
                setSelectedRow(null);
              } else {
                toast.info("Can't update the Expiry date ");
              }
            } else {
              toast.info("Invalid Date");
            }
          } else {
            toast.info("Invalid Date");
          }
        }
      } else {
        toast.info("Invalid Date");
      }
      setDateLoading(false);
    } catch (err) {
      console.log(err);
      log("Error while fetching organization data ", err);
      setDateLoading(false);
    }
  };

  useEffect(() => {
    if (corporation_code) {
      retriveCorporation();
      getOrganizationIds();
      setFieldDisable(true);
      reset();
    }
  }, []);

  return (
    <>
      <div className="grid grid-rows-1">
        <div className="flex overnpmflow-hidden">
          <div className="content relative flex-1 pb-10">
            <h2 className="text-4xl text-[#96BF61] font-bold mb-6">
              Explore Corporation
            </h2>
            {loading && <LoadingSpinner />}
            {!loading && corporation_code && (
              <>
                <h2 className="mt-5 text-xl text-[#96BF61] font-bold mb-6">
                  Corporation code: {corporation_code}
                </h2>
                <div className="grid grid-cols-12 mt-3">
                  <div className="col-span-12 lg:col-span-12">
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="flex flex-col sm:flex-row items-center mb-5">
                        <div className="flex-auto w-1/5 relative">
                          <>
                            <select
                              {...register("organization_code", {
                                onChange: (e) => {
                                  storeFetch(e.target.value);
                                },
                              })}
                              className={`py-3 shadow-md w-full block pl-4 pr-9 mt-0 ${
                                orglLoading ? "bg-gray-200" : "bg-white"
                              } border border-b-2 z-1 focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md`}
                              disabled={orglLoading}
                            >
                              <option className="text-slate-700" value={""}>
                                Select an organization code
                              </option>
                              {organizationIds &&
                                organizationIds.length &&
                                organizationIds.map((val, index) => {
                                  return (
                                    <option key={index} value={val.id}>
                                      {val.id}
                                    </option>
                                  );
                                })}
                            </select>
                            {orglLoading ? (
                              <div className="absolute right-2 top-[13px] pointer-events-none">
                                <SmallLoadingSpinner
                                  className={"w-6 h-6 border-2"}
                                />
                              </div>
                            ) : (
                              <div className="absolute right-2 top-[18px] pointer-events-none">
                                <svg width="17" height="17" viewBox="0 0 24 24">
                                  <path
                                    d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                                    fill="#1D192B"
                                  ></path>
                                </svg>
                              </div>
                            )}
                          </>
                        </div>
                        <div className="flex-auto ml-4 w-1/5 relative">
                          <>
                            <select
                              id="store_code"
                              {...register("store_code")}
                              className={`py-3 shadow-md w-full block pl-4 pr-9 mt-0 ${
                                storeLoading || fieldDisable
                                  ? "bg-gray-200"
                                  : "bg-white"
                              } border border-b-2 z-1 focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md`}
                              disabled={storeLoading || fieldDisable}
                            >
                              <option value={""}>Select a store code</option>
                              {storeIds &&
                                storeIds.length &&
                                storeIds.map((val, index) => {
                                  return (
                                    <option key={index} value={val.id}>
                                      {val.id}
                                    </option>
                                  );
                                })}
                            </select>

                            {storeLoading ? (
                              <div className="absolute right-2 top-[13px] pointer-events-none">
                                <SmallLoadingSpinner
                                  className={"w-6 h-6 border-2"}
                                />
                              </div>
                            ) : (
                              <div className="absolute right-2 top-[18px] pointer-events-none">
                                <svg width="17" height="17" viewBox="0 0 24 24">
                                  <path
                                    d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                                    fill="#1D192B"
                                  ></path>
                                </svg>
                              </div>
                            )}
                          </>
                        </div>
                        <div className="flex-auto ml-4 w-1/5 relative">
                          <input
                            id="location"
                            type="text"
                            {...register("location")}
                            className={`py-3 ${
                              fieldDisable ? "bg-gray-200" : "bg-white"
                            } shadow-md block w-full px-4 mt-0 border border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md`}
                            placeholder="Enter Location"
                            disabled={fieldDisable}
                          />
                        </div>
                        <div className="flex-auto ml-4 w-1/5 relative">
                          <input
                            id="sku"
                            type="text"
                            {...register("sku")}
                            className={`py-3 ${
                              fieldDisable ? "bg-gray-200" : "bg-white"
                            } shadow-md block w-full px-4 mt-0 border border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md`}
                            placeholder="Enter SKU"
                            disabled={fieldDisable}
                          />
                        </div>
                        <div className="flex-auto ml-4 w-1/10 relative">
                          <button
                            type="form"
                            className="px-8 py-3 text-lg text-white transition-all duration-150 ease-linear rounded-md shadow outline-none font-normal bg-[#024C85] hover:bg-[#134d86] hover:shadow-lg focus:outline-none"
                          >
                            Filter
                          </button>
                        </div>
                      </div>
                    </form>
                    <div className="rounded-[21px] rounded-bl-none rounded-br-none">
                      <div className=" overflow-y-scroll rounded-[21px] rounded-bl-none rounded-br-none">
                        <table className="min-w-full border manage-corp-explore">
                          <thead className="border bg-white">
                            <tr>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Organization Code
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Store Code
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Location
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                SKU
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Product Expiry
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {!tableLoading &&
                              organization.length !== 0 &&
                              organization.map((org, index) => {
                                return (
                                  <tr
                                    key={index}
                                    className="bg-white border transition duration-300 ease-in-out hover:bg-gray-100"
                                  >
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3 h-14">
                                      {org.organization_code}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3">
                                      {org.store_code}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3">
                                      {org.location ? org.location : "-"}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3">
                                      {org.sku ? org.sku : "-"}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3">
                                      {(selectedRow === null ||
                                        selectedRow !== index) && (
                                        <div className="pl-2">
                                          {org.expiry_date ? (
                                            <div
                                              onClick={() => {
                                                setSelectedRow(index);
                                                setTempDate(null);
                                              }}
                                              className="flex items-center cursor-pointer"
                                            >
                                              <span className="w-24">
                                                {org.expiry_date}
                                              </span>
                                              <div className="flex justify-start">
                                                <span className="bg-edit block "></span>
                                              </div>
                                            </div>
                                          ) : (
                                            "-"
                                          )}
                                        </div>
                                      )}
                                      {selectedRow === index && (
                                        <div className="flex items-center w-52">
                                          <input
                                            type="date"
                                            className="px-2 border"
                                            id="start"
                                            name="trip-start"
                                            defaultValue={convertToInput(
                                              tempDate || org.expiry_date
                                            )}
                                            min={convertToInput(new Date())}
                                            onChange={(e) =>
                                              handleSpecificDateChange(e, index)
                                            }
                                            disabled={dateLoading}
                                          />
                                          {!dateLoading ? (
                                            <div className="flex">
                                              <button
                                                onClick={() =>
                                                  handleChangeDate(org)
                                                }
                                                className="ml-2 p-1 rounded bg-[#96BF61]"
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  fill="#FFFFFF"
                                                  width="20"
                                                  height="20"
                                                  viewBox="0 0 16 16"
                                                  version="1.1"
                                                >
                                                  <rect
                                                    width="16"
                                                    height="16"
                                                    id="icon-bound"
                                                    fill="none"
                                                  />
                                                  <path d="M0,9.014L1.414,7.6L5.004,11.189L14.593,1.6L16.007,3.014L5.003,14.017L0,9.014Z" />
                                                </svg>
                                              </button>
                                              <button
                                                onClick={() => handleClose()}
                                                className="ml-2 p-1 rounded bg-[#EA7171]"
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  fill="#FFFFFF"
                                                  x="0px"
                                                  y="0px"
                                                  height="20"
                                                  width="20"
                                                  viewBox="0 0 460.775 460.775"
                                                >
                                                  <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55  c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55  c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505  c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55  l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719  c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z" />
                                                </svg>
                                              </button>
                                            </div>
                                          ) : (
                                            <div className="ml-2 px-5">
                                              <SmallLoadingSpinner
                                                className={"w-6 h-6 border-2"}
                                              />
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                            {!tableLoading && organization.length === 0 && (
                              <tr className="bg-white border duration-300 ease-in-out">
                                <td
                                  colSpan={5}
                                  className="border border-r-0 border-l-0 font-light w-30 h-96 text-center px-8 py-4"
                                >
                                  <div className="flex flex-col">
                                    <span className="text-xl font-medium text-gray-600">
                                      No results found
                                    </span>
                                    <span className="text-base mt-3 text-gray-800">
                                      Adjust your Filters and try again
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            )}
                            {tableLoading && (
                              <tr className="bg-white border duration-300 ease-in-out">
                                <td
                                  colSpan={5}
                                  className="border border-r-0 border-l-0 font-light w-30 h-96 px-8 py-4"
                                >
                                  <div className="flex justify-center pointer-events-none">
                                    <div>
                                      <SmallLoadingSpinner
                                        className={
                                          "w-20 h-20 border-8 opacity-60"
                                        }
                                      />
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/*  */}
            {!loading && !corporation_code && organization.length === 0 && (
              <h2 className="text-2xl font-medium mr-auto text-gray-500 text-center mt-[10%]">
                No Data Found!
              </h2>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
